module.exports = __webpack_public_path__ + "img/icon-trending-up.8c021232.svg";